import React, { Component } from 'react';
import Calendar from 'react-calendar';
import { View, Text, StyleSheet } from 'react-native';
import moment from 'moment-timezone';
import { TextInput } from '../../ui';
import Theme from '../../theme';

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCalender: false,
      date: null,
      activeStartDate: null,
      newView: 'century',
      maxDate: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value !== prevProps.value) {
      this.setViewDate();
    }
  }

  setViewDate = () => {
    const { value } = this.props.input;
    this.minDate();
    this.maxDate();
    if (value.length > 0) {
      const dateInCorrectFormat = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD');
      this.setState({ activeStartDate: new Date(dateInCorrectFormat), newView: 'month' });
    } else {
      this.setState({ activeStartDate: this.defaultDate(), newView: 'century' });
    }
  };

  defaultDate = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 20);
    return date;
  };

  maxDate = () => {
    const date = new Date();
    this.setState({ maxDate: date });
    return date;
  };

  minDate = () => {
    const date = new Date();
    date.setFullYear(1901);
    this.setState({ minDate: date });
  };

  setNewDate = (date) => {
    const newDate = moment(date).format('DD-MM-YYYY');
    this.props.input.onChange(newDate);
    this.setState({ showCalender: false, activeStartDate: date });
  };

  whenFocus = () => {
    this.setViewDate();
    this.setState({ showCalender: true });
  };

  setNavigationLabel = (date, view, label) => {
    if (view === 'century') {
      return 'Select year range';
    }
    if (view === 'decade') {
      return 'Select year';
    }
    if (view === 'year') {
      return `Select month in ${date.getFullYear()}`;
    }
    if (view === 'month') {
      return `Select day in ${moment(date).format('MMM YYYY')}`;
    }
    return `${moment(date).format('DD-MM-YYYY')}`;
  };

  render() {
    const {
      showCalender, activeStartDate, newView, maxDate, minDate,
    } = this.state;
    return (
      <View>
        {
          showCalender
            ? (
              <View>
                <Text className='dateofbirth-label'>Date of birth</Text>
                <Calendar
                  onChange={this.setNewDate}
                  maxDate={maxDate}
                  minDate={minDate}
                  activeStartDate={activeStartDate}
                  view={newView}
                  nextLabel={<Text className='nextButton'>›</Text>}
                  next2Label={<Text className='nextButton'>»</Text>}
                  prevLabel={<Text className='nextButton'>‹</Text>}
                  prev2Label={<Text className='nextButton'>«</Text>}
                  navigationLabel={({ date, view, label }) => this.setNavigationLabel(date, view, label)}
                  className='my-calender'
                  tileClassName='calenderItem1'
                  tileContent={({ date, view }) => (view === 'month'
                    && date.getFullYear() === activeStartDate.getFullYear()
                    && date.getMonth() === activeStartDate.getMonth()
                    && date.getDate() === activeStartDate.getDate() ? <Text style={styles.star}>*</Text> : null)}
                />
                <Text
                  style={styles.cancel}
                  className='cancelDate'
                  onPress={() => this.setState({ showCalender: false })}
                >
                  Cancel
                </Text>
              </View>
            ) : <TextInput {...this.props} onFocus={this.whenFocus} />
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  star: {
    color: Theme.PRIMARY,

    fontFamily: Theme.CustomBold,
    fontSize: 27,
  },
  cancel: {
    color: Theme.BLACK,
    textAlign: 'center',
  },
});

DatePicker.propTypes = {
};

export default DatePicker;
